import { optionTitle_eventsForEmail } from 'owa-locstrings/lib/strings/optiontitle_eventsforemail.locstring.json';
import { isFeatureEnabled } from 'owa-feature-flags';
import { OptionSubCategory } from 'owa-options-core';
import loadCalendarMailboxConfiguration from './loadCalendarMailboxConfiguration';
import loadTxpSettings from './loadTxpSettings';
import TxpOption from 'owa-txp-option/lib/TxpOption';
import TxpOptionV2 from 'owa-txp-option/lib/TxpOptionV2';
import { TXP_OPTIONS_V2_FEATURE } from 'owa-calendar-configuration/lib/helpers/TxpConstants';

/**
 * Automatic processing subcategory settings
 */
let eventsFromEmailSubCategory: OptionSubCategory = {
    key: 'calendarInEmail',
    titleStringKey: optionTitle_eventsForEmail,
    options: isFeatureEnabled(TXP_OPTIONS_V2_FEATURE) ? [TxpOptionV2] : [TxpOption],
    onSelected: isFeatureEnabled(TXP_OPTIONS_V2_FEATURE)
        ? loadTxpSettings
        : loadCalendarMailboxConfiguration,
};

export default eventsFromEmailSubCategory;
